<template>
  <div>
    <div class="page-header bordered">
      <h1>Staffers</h1>
    </div>
    <div class="row">
      <div class="col-md-12" align="right">
        <router-link to="/users/staffers/new" class="btn btn-primary float-right">
          <i class="fa fa-plus"></i> Add Staffer
        </router-link>
      </div>
    </div>
    <br/>

    <div v-if="staffers.length > 0">
      <table class="table">
        <thead>
          <tr>
            <th> # </th>
            <th> First Name </th>
            <th> Last Name </th>
            <th> Email </th>
            <th> Last Login </th>
            <th> Actions </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(staffer, index) in staffers" :key="index">
            <td> {{ index }} </td>
            <td> {{ staffer.first_name }} </td>
            <td> {{ staffer.last_name }} </td>
            <td> {{ staffer.email }} </td>
            <td> {{ lastLoginDateStaffer(staffer.last_login_at) }} </td>
            <td>
              <b-button size="sm" variant="info" v-on:click="editStaffer(staffer.id)">
                <i class="fa fa-pencil-square-o"></i>
              </b-button>
              <b-button size="sm" variant="danger" v-on:click="deleteStaffer(staffer.id)">
                <i class="fa fa-trash-o"></i>
              </b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else>
      <b-alert show>
        <h6> No staffers available. </h6>
      </b-alert>
    </div>
  </div>
</template>

<script>
export default {
  name: 'stafferForm',
  data: function () {
    return {
      staffers: []
    }
  },
  created: function () {
    this.getStaffers()
  },
  methods: {
    getStaffers: function () {
      var self = this
      var loader = this.$loading.show()

      this.$http.get('staffers').then(function (response) {
        self.staffers = response.data
      }).finally(function () {
        loader.hide()
      })
    },
    editStaffer: function (stafferId) {
      this.$router.push({ name: 'stafferForm', params: { action: 'edit', id: stafferId } })
    },
    deleteStaffer: function (stafferId) {
      var self = this

      this.$swal({
        title: 'Confirm staffer deletion?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          self.$http.delete('staffers/' + stafferId).then(function (response) {
            self.getStaffers()

            self.$swal({
              title: 'Staffer deleted!',
              type: 'success'
            })
          }).catch(function (error) {
            if (error) {
              self.$swal({
                title: 'Error deleting Staffer!',
                type: 'error'
              })
            }
          })
        }
      })
    },
    lastLoginDateStaffer: function (lastLoginAt) {
      if (lastLoginAt) {
        return moment(lastLoginAt).format('MM/DD/YYYY - HH:mm')
      } else {
        return ' - '
      }
    }
  }
}
</script>
